import Impact from "../components/Impact";
import Stories from "../components/Stories";

export default function ImpactPage() {
  return (
    <div data-testid="impact-page">
      <Impact />
      <Stories />
    </div>
  );
}
